import { render, staticRenderFns } from "./DASQuestionnairePanels.vue?vue&type=template&id=0fc85d48&"
import script from "./DASQuestionnairePanels.vue?vue&type=script&lang=js&"
export * from "./DASQuestionnairePanels.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/questionnaires/components/lasa-questionnaire-panels.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports